<template>
  <div class="mt-2">
    <card id="ler_step1_propLocInfoCard" tabindex="0">
      <div slot="header">
        <h3 class="card-title" align="center">매물 위치 정보</h3>
      </div>

      <div class="row ml-0 mr-0">
        <div class="col-lg-8 fl pl-0">
          <div class="mb-30">
            <h6 class="mb-0">
              <i class="fas fa-exclamation-circle"></i>
              건축물대장 상의 주소를 입력해주세요. 건축물대장에서 자동으로 매물
              정보를 불러옵니다.
            </h6>
            <h6>
              <i class="fas fa-exclamation-circle"></i>
              도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
            </h6>
          </div>

          <!-- 주소 -->
          <div class="row m-row">
            <label class="col-lg-2 col-md-12 col-form-label px-0">주소</label>
            <div class="col-lg-10 col-md-12 col-sm-12 px-0">
              <div
                class="fl r-noradius btn-pct-m jipvio-bg-white"
                style="width: 90%"
              >
                <ValidationProvider
                  rules="required"
                  v-slot="{ failed }"
                  vid="propertyRAddrVal"
                >
                  <fg-input
                    ref="propertyAddrBoxRef"
                    innerRef="propertyRAddr_inner"
                    type="text"
                    :error="failed ? '매물 주소를 입력해주세요' : null"
                    placeholder="주소 (required)"
                    v-model="propertyRAddr"
                    @keyup.enter.native="addressPop"
                    @click="addressPop"
                    :disabled="Disabled"
                  >
                  </fg-input>
                </ValidationProvider>
              </div>

              <div class="fl btn-pct-b" style="width: 10%">
                <el-button
                  class="el-btn-height jip-cont-btn l-noradius"
                  icon="el-icon-search"
                  @click="addressPop"
                  :disabled="Disabled"
                ></el-button>
              </div>
              <!-- daum -->
              <span
                id="guide"
                class="fl"
                style="color: rgb(153, 153, 153); display: block"
              ></span>
            </div>
          </div>

          <!--상세주소 -->
          <div class="row m-row">
            <label class="col-lg-2 col-md-12 col-form-label px-0"
              >상세주소</label
            >
            <div class="col-lg-10 col-md-12 col-sm-12 px-0">
              <div class="col-md-6 fl pb-10 px-0">
                <div class="fullWidth">
                  <!-- <label class="fl col-form-label" style="width:15%">동</label> -->
                  <el-select
                    ref="dongSelectRef"
                    class="addrSelectWidth"
                    style="width: 100%"
                    v-model="selectedDongIdx"
                    placeholder="동"
                    @change="bringHoFlr()"
                    :disabled="dongDisable || Disabled"
                  >
                    <el-option
                      v-for="(bdl, i) in bdList"
                      :key="i"
                      :label="changeDong(bdl.dongNm)"
                      :value="i"
                    ></el-option>
                  </el-select>
                </div>
              </div>

              <div class="col-md-6 fl pb-10 px-0">
                <div class="fullWidth">
                  <!-- <label class="fl col-form-label" style="width:15%">호</label> -->
                  <el-select
                    ref="hoSelectRef"
                    class="addrSelectWidth"
                    style="width: 100%"
                    v-model="selectedHo"
                    placeholder="호"
                    @change="
                      getFullRAddress();
                      getFullJAddress();
                    "
                    :disabled="hoDisable || Disabled"
                  >
                    <el-option
                      v-for="(ho, i) in hoList"
                      :key="i"
                      :label="changeHo(ho)"
                      :value="ho"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-12 fl pb-10 px-0">
                <h6 class="mb-0">
                  <i class="fas fa-exclamation-circle"></i>
                  건축물대장에 동, 호수가 없는 경우: 층 선택 후 임대할 면적을
                  입력합니다.
                </h6>
              </div>
              <div class="col-md-6 fl pb-0 px-0">
                <div class="fullWidth jipvio-bg-white">
                  <!-- .form-control[readonly]색 white로 바꿈 -->
                  <!-- <label class="fl col-form-label" style="width:15%">층</label> -->
                  <ValidationProvider rules="required" vid="selectedFlrVal">
                    <fg-input
                      type="text"
                      class="fl addrSelectWidth"
                      style="width: 100%"
                    >
                      <el-select
                        ref="flrSelectRef"
                        placeholder="층"
                        style="width: 100%"
                        v-model="selectedFlr"
                        @change="
                          getFullRAddress();
                          getFullJAddress();
                        "
                        :disabled="Disabled"
                      >
                        <el-option
                          v-for="flrl in flrList"
                          :key="flrl.index"
                          :label="changeFlr(flrl)"
                          :value="flrl"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </ValidationProvider>
                </div>
              </div>

              <div class="fl col-12 pb-10 px-0" v-if="flrCheckShow">
                <div class="fl col-xl-3 px-0">
                  <el-checkbox
                    ref="allFloorBoxRef"
                    label="전체"
                    class="fl col-6 m-0 col-form-label pl-0"
                    v-model="allFloor"
                    :disabled="partFloor || Disabled"
                  ></el-checkbox>

                  <el-checkbox
                    label="일부"
                    class="fl col-6 px-0 col-form-label"
                    v-model="partFloor"
                    :disabled="allFloor || Disabled"
                    @change="partArea = null"
                  ></el-checkbox>
                </div>
                <div class="fl col-xl-6 px-0" v-show="partFloor === true">
                  <el-input
                    ref="partAreaBoxRef"
                    class="fl"
                    type="number"
                    style="width: 48%"
                    v-model="partArea"
                    :disabled="Disabled"
                  >
                    <template slot="append">m²</template>
                  </el-input>
                  <!-- <label class="fl col-form-label" style="width:">m²</label> -->
                  <el-input
                    ref="hoTitleBoxRef"
                    class="fr"
                    style="width: 48%"
                    v-model="hoTitle"
                    :disabled="Disabled"
                  >
                    <template slot="append">명칭</template>
                  </el-input>
                  <!-- <label class="fl col-form-label" style="">명칭</label> -->
                </div>
              </div>
            </div>
          </div>

          <!-- 주소 정보 -->
          <div class="row m-row pb-10">
            <label class="col-lg-2 col-md-12 col-form-label px-0"
              >주소정보</label
            >
            <div class="col-lg-10 col-md-12 col-sm-12 px-0">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="Please input"
                v-model="fullAddr"
                :disabled="Disabled"
              ></el-input>
            </div>
          </div>
        </div>

        <!-- map -->
        <div class="col-lg-4 fl pl-0">
          <div class="pptInquiry_map_wrap">
            <div class="pptInquiry_map_inner" id="step1Map" align="right"></div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import openApi from "@/service/openapi";
import { ErrorBag } from "vee-validate";
import { Validator } from "vee-validate";
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

import {
  Card,
  Form,
  FormItem,
  Button,
  Checkbox,
  Input,
  Select,
  Option,
  Message,
  Notification
} from "element-ui";

export default {
  props: {
    Disabled: {
      type: Boolean
    }
  },
  components: {
    Card,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option
  },

  data() {
    return {
      //==================================
      propertyRAddr: null,
      propertyLat: null, // 매물 위도
      propertyLong: null, // 매물 경도

      selectedDongIdx: null,

      genBdList: null, //총괄표제부
      bdList: [], //표제부 리스트,

      hoList: [], //호 리스트
      selectedHo: null, // 선택된 호 index

      flrList: [], //층 리스트
      selectedFlr: null, //선택된 층수

      legalDong: null, // 법정동

      allFloor: false,
      partFloor: false,
      partArea: null, // 직접입력한 면적
      hoTitle: null, // 직접입력한 호 명칭
      flrCheckShow: false, // 전체,일부 체크박스 Show 여부

      brdList: [], // 용도지역 리스트

      newBun: null, // for문으로 만든 bun
      newJi: null, // for문으로 만든 ji
      jiBun: null, // 지번주소의 지번
      legalDong: null, // 법정동

      locationInfo: {}, // 매물 주소 총정보
      fullRAddr: this.fullRAddr, //주소+동호층 (도로명)
      fullJAddr: this.fullJAddr, //주소+동호층 (지번)

      jipvioMarker: null,
      jipvioMap: null,
      jipvioGeocoder: null,

      dongDisable: false,
      hoDisable: false
    };
  },
  created() {
    this.bringData();
  },

  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      const serviceKey = process.env.VUE_APP_KKO_SDK_KEY;

      script.onload = () => kakao.maps.load(this.initMap);

      script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${serviceKey}&libraries=services`;
      // <head></head>에 위치
      document.head.appendChild(script);
    }
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    fullAddr() {
      if (this.fullRAddr == null || this.fullJAddr == null) {
        return "도로명: " + "\n" + "지번:";
      } else {
        return "도로명: " + this.fullRAddr + "\n" + "지번:" + this.fullJAddr;
      }
    },

    modifiedDong() {
      if (
        this.selectedDongIdx != null &&
        this.bdList[this.selectedDongIdx].dongNm.charAt(
          this.bdList[this.selectedDongIdx].dongNm.length - 1
        ) == "동"
      ) {
        return this.bdList[this.selectedDongIdx].dongNm.slice(0, -1);
      } else if (this.selectedDongIdx != null) {
        return this.bdList[this.selectedDongIdx].dongNm;
      } else {
        return null;
      }
    },

    modifiedHo() {
      if (this.selectedHo.charAt(this.selectedHo.length - 1) == "호") {
        return this.selectedHo.slice(0, -1);
      } else {
        return this.selectedHo;
      }
    },

    modifiedFlr() {
      if (
        this.selectedFlr != null &&
        this.selectedFlr.charAt(this.selectedFlr.length - 1) == "층"
      ) {
        return this.selectedFlr.slice(0, -1);
      } else if (this.selectedFlr != null) {
        return this.selectedFlr;
      } else {
        return null;
      }
    }
  },

  methods: {
    bringData() {
      console.log(this.sessionPropertyInquiry.certification);

      this.propertyRAddr = this.sessionPropertyInquiry.certification.propertyRAddr; //매물 도로명 주소
      this.propertyLat = this.sessionPropertyInquiry.certification.propertyLat; // 매물 위도
      this.propertyLong = this.sessionPropertyInquiry.certification.propertyLong; // 매물 경도

      this.locationInfo = this.sessionPropertyInquiry.certification.locationInfo; // 매물 주소 총정보
      this.fullRAddr = this.sessionPropertyInquiry.certification.fullRAddr; //매물 full도로명
      this.fullJAddr = this.sessionPropertyInquiry.certification.fullJAddr; //매물 full지번

      this.dongDisable = this.sessionPropertyInquiry.certification.dongDisable;
      this.hoDisable = this.sessionPropertyInquiry.certification.hoDisable;

      this.allFloor = this.sessionPropertyInquiry.certification.allFloor;
      this.partFloor = this.sessionPropertyInquiry.certification.partFloor;
      this.partArea = this.sessionPropertyInquiry.certification.partArea; // 직접입력한 면적
      this.hoTitle = this.sessionPropertyInquiry.certification.hoTitle; // 직접입력한 호 명칭
      this.flrCheckShow = this.sessionPropertyInquiry.certification.flrCheckShow; // 전체,일부 체크박스 Show 여부

      this.newBun = this.sessionPropertyInquiry.certification.newBun; // for문으로 만든 bun
      this.newJi = this.sessionPropertyInquiry.certification.newJi; // for문으로 만든 ji

      this.brdList = this.sessionPropertyInquiry.certification.brdList; // 용도지역 리스트
      this.genBdList = this.sessionPropertyInquiry.certification.genBdList; //총괄표제부
      this.bdList = this.sessionPropertyInquiry.certification.bdList; //표제부 리스트

      this.selectedDongIdx = this.sessionPropertyInquiry.certification.selectedDongIdx; //선택된 동

      this.hoList = this.sessionPropertyInquiry.certification.hoList; //호 리스트
      this.selectedHo = this.sessionPropertyInquiry.certification.AddrHo; // 선택된 호 index

      this.flrList = this.sessionPropertyInquiry.certification.flrList; //층 리스트
      this.selectedFlr = this.sessionPropertyInquiry.certification.AddrFloor; //선택된 층수
    },

    //=================================================================

    getFullRAddress() {
      if (this.locationInfo.roadAddress == null) {
        this.fullRAddr = null;
      } else if (this.selectedDongIdx == null) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullRAddr = this.locationInfo.roadAddress;
          } else {
            this.fullRAddr =
              this.locationInfo.roadAddress + " " + this.modifiedFlr + "층";
          }
        } else {
          this.fullRAddr =
            this.locationInfo.roadAddress + " " + this.modifiedHo + "호";
        }
      } else {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullRAddr =
              this.locationInfo.roadAddress + " " + this.modifiedDong + "동 ";
          } else {
            this.fullRAddr =
              this.locationInfo.roadAddress +
              " " +
              this.modifiedDong +
              "동 " +
              this.modifiedFlr +
              "층";
          }
        } else {
          this.fullRAddr =
            this.locationInfo.roadAddress +
            " " +
            this.modifiedDong +
            "동 " +
            this.modifiedHo +
            "호";
        }
      }
    },

    getFullJAddress() {
      if (this.locationInfo.jibunAddress == null) {
        this.fullJAddr = null;
      } else if (this.selectedDongIdx == null) {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullJAddr = this.locationInfo.jibunAddress;
          } else {
            this.fullJAddr =
              this.locationInfo.jibunAddress + " " + this.modifiedFlr + "층";
          }
        } else {
          this.fullJAddr =
            this.locationInfo.jibunAddress + " " + this.modifiedHo + "호";
        }
      } else {
        if (this.selectedHo == null) {
          if (this.selectedFlr == null || this.selectedFlr == "") {
            this.fullJAddr =
              this.locationInfo.jibunAddress + " " + this.modifiedDong + "동 ";
          } else {
            this.fullJAddr =
              this.locationInfo.jibunAddress +
              " " +
              this.modifiedDong +
              "동 " +
              this.modifiedFlr +
              "층";
          }
        } else {
          this.fullJAddr =
            this.locationInfo.jibunAddress +
            " " +
            this.modifiedDong +
            "동 " +
            this.modifiedHo +
            "호";
        }
      }
    },

    /* 도로명 선택 할 경우 나오는 메세지 */
    notify: function() {
      Notification.warning({
        title: "Warning",
        message: "지번을 선택해 주세요"
      });
    },

    addressPop() {
      const self = this;
      new daum.Postcode({
        oncomplete: function(data) {
          // 도로명을 눌렀을 경우
          if (data.userSelectedType === "R") {
            self.notify();
            return;
          }
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          var extraRoadAddr = ""; // 참고 항목 변수

          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraRoadAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraRoadAddr +=
              extraRoadAddr !== ""
                ? ", " + data.buildingName
                : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraRoadAddr !== "") {
            extraRoadAddr = " (" + extraRoadAddr + ")";
          }

          var guideTextBox = document.getElementById("guide");
          // 사용자가 '선택 안함'을 클릭한 경우, 예상 주소라는 표시를 해준다.
          if (data.autoRoadAddress) {
            var expRoadAddr = data.autoRoadAddress + extraRoadAddr;
            guideTextBox.innerHTML = "(예상 도로명 주소 : " + expRoadAddr + ")";
            guideTextBox.style.display = "block";
          } else if (data.autoJibunAddress) {
            var expJibunAddr = data.autoJibunAddress;
            guideTextBox.innerHTML = "(예상 지번 주소 : " + expJibunAddr + ")";
            guideTextBox.style.display = "block";
          } else {
            guideTextBox.innerHTML = "";
            guideTextBox.style.display = "none";
          }
          self.targetJuso(data);
          this.autoClose = true;
        }
      }).open({
        left: window.screen.width / 2 - 500 / 2,
        top: window.screen.height / 2 - 600 / 2,
        autoClose: false
      });
      // const popupX = (window.screen.width - 450) / 2;
      // const popupY = (window.screen.height - 500) / 2;
      // var pop = window.open(
      //   "./extension/juso.html",
      //   "pop_basic",
      //   "width=450,height=550,scrollbars=yes,resizable=yes,left=" +
      //     popupX +
      //     ",top=" +
      //     popupY
      // );
    },

    /* daum주소 솔류션에서 받은 데이터 */
    async targetJuso(data) {
      this.$emit("loading");

      console.log("--------------jusoData");

      this.locationInfo = data;

      this.propertyRAddr = this.locationInfo.roadAddress;
      this.legalDong = this.locationInfo.bname;
      console.log(this.locationInfo);

      this.changeMap();
      // 시군구 코드와 법정동 코드 -> 건축물대장
      this.bdList = null;
      this.hoList = null;
      this.flrList = null;
      this.selectedDongIdx = null;
      this.selectedHo = null;
      this.selectedFlr = null;
      this.dongDisable = false;
      this.hoDisable = false;
      this.allFloor = false;
      this.partFloor = false;
      this.partArea = null;
      this.flrCheckShow = false;

      this.getFullRAddress();
      this.getFullJAddress();

      /* 지번(duam) */
      const jibun = this.locationInfo.jibunAddress.match(
        / [0-9]{1,4}-[0-9]{0,4}$/g
      );
      /* 지(duam) */
      let ji = this.locationInfo.jibunAddress.match(/[0-9]{1,4}$/g);
      if (ji == 0 || ji == null) {
        ji = "0";
      } else {
        ji = ji[0];
      }
      /* 번(duam) */
      let bun = "";

      /* "지"가 아무것도 없을 경우(duam) */
      if (jibun == null || jibun == 0) {
        bun = ji;
        ji = "0";
      } else {
        /* 지번 */
        this.jibun = this.locationInfo.jibunAddress.match(
          / [0-9]{1,4}-[0-9]{0,4}$/g
        )[0];
        /* 번 */
        bun = this.jibun.substr(1, this.jibun.length - (ji.length + 2));
      }

      /* 지번 공공데이터에 맞게 변환 */
      const jiLength = ji.length;
      const bunLength = bun.length;
      for (let i = 0; i < 4 - bunLength; i++) {
        bun = "0" + bun;
      }
      for (let i = 0; i < 4 - jiLength; i++) {
        ji = "0" + ji;
      }

      this.newBun = bun;
      this.newJi = ji;

      console.log("=========newBunNewji");
      console.log(this.newBun);
      console.log(this.newJi);
      // 표제부 / 총괄 표제부 / etc ...
      const propInfo = {
        sigunguCd: data.bcode.substring(0, 5) /* daum */,
        bjdongCd: data.bcode.substring(5, 10) /* duam */,
        bun: bun,
        ji: ji
      };

      let res = await openApi.getPropInfo(propInfo);
      console.log(res);

      if (res.status != 200) {
        this.$emit("loading");
        Message({
          message: "다시 검색해주세요.",
          type: "error"
        });
        return;
      }

      if (res.payload.bdRegDistrictInfoList.length > 0) {
        this.brdList = [];
        console.log(res.payload.bdRegDistrictInfoList);
        res.payload.bdRegDistrictInfoList.forEach(brdl => {
          if (
            brdl.etcJijigu == null ||
            brdl.etcJijigu == " " ||
            brdl.etcJijigu == ""
          ) {
            this.brdList.push(brdl.jijiguCdNm);
          } else {
            this.brdList.push(brdl.etcJijigu);
          }
        });
      } else {
        this.brdList = [];
      }
      //총괄표제부
      this.genBdList = res.payload.bdRegGenTitleList;

      // 표제부
      this.bdList = res.payload.bdRegTitleList;

      if (res.payload.bdRegGenTitleList.length == 0) {
        console.log("총괄표제부 없음");
        // 총괄표제부 없다는 것은 동이 존재하지 않음.
        this.dongDisable = true;

        propInfo.dongNm =
          this.bdList[0].dongNm === " " ? null : this.bdList[0].dongNm;

        res = await openApi.getAllPropHoFlr(propInfo);
        console.log(propInfo);

        if (res.payload.hoList.length == 0) {
          this.hoDisable = true;
        }

        this.hoList = res.payload.hoList;
        this.flrList = res.payload.flrList;
        if (this.hoList.length == 0) {
          this.flrCheckShow = true;
        }
      }
      this.$emit("loading");
    },

    //===============================================================================20201106 him
    initMap() {
      var self = this;

      const container = document.getElementById("step1Map");
      var options = {
        // required : 위도(latitude), 경도(longitude)
        center: new kakao.maps.LatLng(33.450705, 126.570677),
        level: 3
      };

      this.jipvioMap = new kakao.maps.Map(container, options);
      this.jipvioGeocoder = new kakao.maps.services.Geocoder();

      // 마커를 생성합니다
      var marker = new kakao.maps.Marker({
        position: new kakao.maps.LatLng(33.450705, 126.570677), // 마커를 표시할 위치
        title: "카카오" // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
      });
      self.jipvioMarker = marker;
      self.jipvioMarker.setMap(this.jipvioMap);

      if (this.propertyLat !== null || this.propertyLong !== null) {
        this.changeMap();
      }
    },

    //===============================================================================20201106 him
    changeMap() {
      const self = this;

      //마크 지우기
      self.jipvioMarker.setMap(null);
      self.jipvioMarker = null;

      this.jipvioGeocoder.addressSearch(
        // this.locationInfo.roadFullAddr,
        this.locationInfo.roadAddress,
        function(result, status) {
          if (status === kakao.maps.services.Status.OK) {
            self.propertyLat = result[0].y;
            self.propertyLong = result[0].x;
            var coords = new kakao.maps.LatLng(result[0].y, result[0].x);

            //마커 생성
            var marker = new kakao.maps.Marker({
              position: coords
            });

            self.jipvioMarker = marker;
            self.jipvioMarker.setMap(self.jipvioMap);

            //센터 이동
            self.jipvioMap.setCenter(coords);
          }
        }
      );
    },

    async bringHoFlr() {
      this.$emit("loading");
      this.hoDisable = false;
      this.selectedHo = null;
      this.selectedFlr = null;
      this.hoList = [];
      this.flrList = [];

      this.getFullRAddress();
      this.getFullJAddress();

      const propInfo = {
        // sigunguCd: this.locationInfo.admCd.substring(0, 5),
        // bjdongCd: this.locationInfo.admCd.substring(5, 10),
        sigunguCd: this.locationInfo.bcode.substring(0, 5) /* daum */,
        bjdongCd: this.locationInfo.bcode.substring(5, 10) /* daum */,
        bun: this.newBun,
        ji: this.newJi,
        dongNm: this.bdList[this.selectedDongIdx].dongNm
      };

      const res = await openApi.getAllPropHoFlr(propInfo);

      if (res.status != 200) {
        this.$emit("loading");
        Message({
          message: "다시 시도해주세요.",
          type: "error"
        });
        return;
      }

      if (res.payload.hoList.length == 0) {
        this.hoDisable = true;
      }
      this.flrList = res.payload.flrList;
      this.hoList = res.payload.hoList;

      this.$emit("loading");
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    changeDong(val) {
      return val.charAt(val.length - 1) === "동" ? val : `${val}동`;
    },

    changeHo(val) {
      return val.charAt(val.length - 1) === "호" ? val : `${val}호`;
    },

    changeFlr(val) {
      return val.charAt(val.length - 1) === "층" ? val : `${val}층`;
    },
    SendInfo() {
      let locationInfo = {
        propertyRAddr: this.propertyRAddr,
        propertyLat: this.propertyLat,
        propertyLong: this.propertyLong,
        selectedDongIdx: this.selectedDongIdx,
        genBdList: this.genBdList,
        bdList: this.bdList,
        hoList: this.hoList,
        selectedHo: this.selectedHo,
        flrList: this.flrList,
        selectedFlr: this.selectedFlr,
        legalDong: this.legalDong,
        allFloor: this.allFloor,
        partFloor: this.partFloor,
        partArea: this.partArea,
        hoTitle: this.hoTitle,
        flrCheckShow: this.flrCheckShow,
        brdList: this.brdList,
        newBun: this.newBun,
        newJi: this.newJi,
        jiBun: this.jiBun,
        legalDong: this.legalDong,
        locationInfo: this.locationInfo,
        fullRAddr: this.fullRAddr,
        fullJAddr: this.fullJAddr,
        dongDisable: this.dongDisable,
        hoDisable: this.hoDisable
      };
      this.$emit("SendLoactionInfo", locationInfo);
    }
  }
};
</script>

<style></style>
